import { Stack, Typography } from '@mui/material';
import { FC } from 'react';

type DisabledRuleItemProps = {
  name: string;
  valueName?: string;
  value: string | JSX.Element;
  description?: string | JSX.Element;
  descriptionName?: string;
};

export const DisabledRuleItem: FC<DisabledRuleItemProps> = ({
  name,
  value,
  valueName,
  description,
  descriptionName,
}) => {
  return (
    <Stack direction="row" gap="24px">
      <Typography color="grey.700" variant="label14Bold" lineHeight="18px" component="p" minWidth="180px">
        {name}
      </Typography>

      <Typography color="grey.700" variant="label12Bold" lineHeight="18px" minWidth="138px">
        {valueName}
        <Typography color="grey.700" variant="label12Medium" lineHeight="18px" marginLeft={valueName ? '8px' : '0'}>
          {value || '-'}
        </Typography>
      </Typography>

      {(descriptionName || description) && (
        <Typography color="grey.700" variant="label12Bold" lineHeight="18px">
          {descriptionName}
          {typeof description === 'string' ? (
            <Typography color="grey.700" variant="label12Medium" lineHeight="18px" flexShrink={0} marginLeft="8px">
              {description}
            </Typography>
          ) : (
            description
          )}
        </Typography>
      )}
    </Stack>
  );
};
